import type { SVGProps } from "react";
import React from "react";

export const ChevronRightIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.63691 4.11649C7.49109 3.96101 7.25484 3.96119 7.10922 4.11689C6.96361 4.27259 6.96378 4.52484 7.1096 4.68032L12.0989 10L7.1096 15.3197C6.96378 15.4752 6.96361 15.7274 7.10922 15.8831C7.25484 16.0388 7.49109 16.039 7.63691 15.8835L12.8906 10.282C12.963 10.2047 12.9995 10.1037 13.0001 10.0024C13.0007 9.89954 12.9642 9.7965 12.8906 9.71807L7.63691 4.11649Z"
      fill={fill}
    />
  </svg>
);
